import { FC } from 'react';
import { Bell } from 'react-feather';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'recompose';
import styled from 'styled-components';

import { GET_NOTIFICATIONS } from '../../graphql';
import { useRouter } from '../../hooks';

type NotificationsIconProps = {
  data?: {
    notifications: {
      edges: {
        node: {
          id: string;
          read: boolean;
        };
      }[];
    };
  };
  notificationsURL: string;
};

const NotificationContainer = styled.div`
  margin-right: 0;
  position: relative;
`;

const RoundRedCounter = styled.div`
  background-color: red;
  border-radius: 6px;
  color: #fff;
  font-size: 0.6em;
  font-weight: 600;
  height: 12px;
  left: 10px;
  padding: 0.5px;
  position: absolute;
  text-align: center;
  top: -4px;
  width: 12px;
`;

const NotificationsIcon: FC<NotificationsIconProps> = ({ data, notificationsURL }) => {
  const { history, match } = useRouter();
  // "count" should reflect only unread notifications
  const unreadNotifications =
    data && data.notifications && data.notifications.edges.filter(edge => edge.node.read === false);
  const count = (unreadNotifications && unreadNotifications.length) || 0;

  return (
    <NotificationContainer
      onClick={() => {
        if (match.url.includes('notifications')) {
          history.goBack();
        } else {
          history.push(notificationsURL);
        }
      }}
    >
      <RoundRedCounter>{count}</RoundRedCounter>
      <Bell />
    </NotificationContainer>
  );
};

export default compose<any, NotificationsIconProps>(
  graphql(GET_NOTIFICATIONS, {
    name: 'data',
    options: {
      variables: {
        input: {
          first: 10,
        },
      },
    },
  })
)(NotificationsIcon);
